const infoManual =
  "以下の職員の配置換えを行います。\\n問題なければ「はい」をクリック、修正が必要な場合には「いいえ」をクリックしてください。";

const infoHeadTitleList: any[] = [
  { headTitle: "氏名" },
  { headTitle: "配置換え前施設名" },
  { headTitle: "配置換え後施設名" },
  { headTitle: "配置換え年月日" },
];

const stepper = [
  "職員選択/配置換え入力",
  "配置換え確認",
  "登録完了",
];
export { infoManual, infoHeadTitleList, stepper};
